import modelBaseV2 from '../../models/model-base-v2.model';


var scheduleManualTriggerModel = {   
    getUsers:(filter)=>{
        let parms = Object.keys(filter).map(function(k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(filter[k])
        }).join('&');
        return modelBaseV2.get(`/api/schedule/users?${parms}`);
    },
    getJPOStatus:(filter)=>{
        return modelBaseV2.post(`/api/jpo/routeschedule/status`, { body: filter });
    },
    queue:(parms)=>{
        return modelBaseV2.post(`/api/jpo/routeschedule/queue`,{ body: parms });
    }
}
export default scheduleManualTriggerModel;